document.addEventListener('DOMContentLoaded', () => {

  // 1. Helper function to open the expandable
  const openExpandable = (toggler) => {
    const targetSelector = toggler.dataset.target;
    const closeLabel = toggler.dataset.close;
    const targetEl = document.querySelector(targetSelector);

    if (targetEl) {
      const innerEl = targetEl.querySelector('.kai-expandable-inner');
      // offsetHeight is the vanilla equivalent to jQuery's outerHeight()
      const targetHeight = innerEl ? innerEl.offsetHeight : 0; 
      targetEl.style.height = targetHeight + 'px';
    }
    
    if (closeLabel) toggler.innerHTML = closeLabel;
  };

  // 2. Helper function to close the expandable
  const closeExpandable = (toggler) => {
    const targetSelector = toggler.dataset.target;
    const openLabel = toggler.dataset.open;
    const targetEl = document.querySelector(targetSelector);

    if (targetEl) {
      targetEl.style.height = '0px';
    }
    
    if (openLabel) toggler.innerHTML = openLabel;
  };

  // 3. Initial setup: trigger "close-expandable" on load
  document.querySelectorAll('.kai-toggler').forEach(toggler => {
    closeExpandable(toggler);
    toggler.classList.add('closed'); // Ensure the logic matches the closed state
  });

  // 4. Click Event Delegation (handles clicks even if elements are added dynamically later)
  document.body.addEventListener('click', (e) => {
    // e.target.closest ensures it works even if you click a span/icon inside the toggler
    const toggler = e.target.closest('.kai-toggler');
    if (!toggler) return;

    if (toggler.classList.contains('closed')) {
      openExpandable(toggler);
      toggler.classList.remove('closed');
    } else {
      closeExpandable(toggler);
      toggler.classList.add('closed');
    }
  });

});